import React, { Component } from "react";
import { connect } from "react-redux";

import { setPopup, showMessage } from "../actions/siteActions";

class Message extends Component {
  constructor(props) {
    super(props);
    this.state = {
      classState: "",
    };
  }
  componentDidMount = () => {
    setTimeout(
      function () {
        this.setState({
          classState: "start",
        });
      }.bind(this),
      10
    );
    setTimeout(
      function () {
        this.destroyMessage();
      }.bind(this),
      3000
    );
  };

  destroyMessage = () => {
    this.setState({
      classState: "end",
    });
    setTimeout(
      function () {
        this.props.showMessage(false);
        this.props.setPopup("", false);

      }.bind(this),
      300
    );
  };

  render() {
    const { site } = this.props;
    return (
      <div className={`message ${this.state.classState}`}>
        {site.message.text}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  site: state.site,
});

export default connect(mapStateToProps, { setPopup, showMessage })(Message);
